import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FormHeader } from 'components/_basic/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { EstimatedTaxRateSection, ProfitAndLossProjectionFormTable } from './components';

export const ProfitAndLossProjection: FC = () => {
  const { t } = useTranslation();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.FINANCIAL_PLAN,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_FINANCIAL_PLAN.PROFIT_AND_LOSS_PROJECTION,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader title={t('financialPlan.title')} badgeText={t('financialPlan.profitAndLossProjection.title')} />
      </FormSectionCard>

      <ProfitAndLossProjectionFormTable disabled={!canAccess} />

      <EstimatedTaxRateSection
        title={t('financialPlan.profitAndLossProjection.estimatedTaxRate')}
        disabled={!canAccess}
      />
    </>
  );
};
